import { computed, ref, Ref } from "@vue/composition-api";
import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import { VaultFileUsageSubjectTypeEnum } from "@scrile/api-provider/dist/api/VaultsProvider";

export const useFilterVaultFiles = (
  filterSubject?: Ref<Subject<VaultFileUsageSubjectTypeEnum.MESSAGE_THREAD> | undefined>
) => {
  const showUnusedFiles = ref(false);
  const filterByUnused = computed<Subject<VaultFileUsageSubjectTypeEnum.MESSAGE_THREAD> | undefined>(() => {
    if (showUnusedFiles.value && filterSubject?.value) {
      return filterSubject?.value;
    }
    return;
  });

  return {
    filterByUnused,
    showUnusedFiles,
  };
};
